import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import { toast } from 'react-toastify';

const fmt = (n) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(n || 0);

export default function AdminPlanes() {
  const [planes, setPlanes] = useState([]);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(true);

  const cargar = () => {
    api.get('/admin/planes').then(r => setPlanes(r.data)).finally(() => setLoading(false));
  };
  useEffect(cargar, []);

  const toggleActivo = async (plan) => {
    try {
      await api.put(`/admin/planes/${plan.id}`, { activo: plan.activo ? 0 : 1 });
      cargar();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error');
    }
  };

  return (
    <div style={{ padding: 28 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: 'var(--text-1)' }}>Planes de Suscripción</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-3)', fontSize: 14 }}>Gestiona los planes y precios de Prestam.io</p>
        </div>
        <button onClick={() => setModal({})} style={{ padding: '9px 20px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
          + Nuevo Plan
        </button>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', color: 'var(--text-3)', padding: 60 }}>Cargando...</div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 20 }}>
          {planes.map(p => (
            <div key={p.id} style={{
              background: 'var(--bg-card)', borderRadius: 16, padding: 24,
              border: `2px solid ${p.activo ? p.color : '#334155'}40`,
              opacity: p.activo ? 1 : 0.6,
              position: 'relative'
            }}>
              {!p.activo && (
                <div style={{ position: 'absolute', top: 12, right: 12, background: 'var(--bg-hover)', color: 'var(--text-3)', fontSize: 10, padding: '2px 8px', borderRadius: 10, fontWeight: 600 }}>INACTIVO</div>
              )}
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16 }}>
                <div style={{ width: 12, height: 12, borderRadius: '50%', background: p.color, flexShrink: 0 }} />
                <h3 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: 'var(--text-1)' }}>{p.nombre}</h3>
              </div>
              {p.descripcion && <p style={{ margin: '0 0 16px', color: 'var(--text-3)', fontSize: 13 }}>{p.descripcion}</p>}

              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 28, fontWeight: 700, color: p.color }}>{fmt(p.precio_mensual)}<span style={{ fontSize: 13, color: 'var(--text-3)', fontWeight: 400 }}>/mes</span></div>
                {p.precio_anual && <div style={{ fontSize: 13, color: 'var(--text-3)', marginTop: 2 }}>{fmt(p.precio_anual)}/año</div>}
              </div>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16, fontSize: 13 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: 'var(--text-3)' }}>Sillas máximas</span>
                  <span style={{ color: 'var(--text-1s)', fontWeight: 600 }}>{p.max_sillas === 200 ? 'Sin límite' : p.max_sillas}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: 'var(--text-3)' }}>Cobros/mes</span>
                  <span style={{ color: 'var(--text-1s)' }}>{p.max_cobros_mes === 0 ? 'Ilimitados' : p.max_cobros_mes.toLocaleString()}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: 'var(--text-3)' }}>Soporte</span>
                  <span style={{ color: 'var(--text-1s)', textTransform: 'capitalize' }}>{p.soporte}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ color: 'var(--text-3)' }}>Módulo ventas</span>
                  <span style={{ color: p.modulo_ventas ? '#34d399' : '#475569', fontWeight: 600 }}>{p.modulo_ventas ? '✓ Incluido' : '✗ No incluido'}</span>
                </div>
              </div>

              <div style={{ background: 'var(--bg-app)', borderRadius: 8, padding: '10px 12px', marginBottom: 16, display: 'flex', justifyContent: 'space-between', fontSize: 13 }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontWeight: 700, color: '#22d3ee', fontSize: 18 }}>{p.suscripciones_activas || 0}</div>
                  <div style={{ color: 'var(--text-3)', fontSize: 11 }}>Clientes activos</div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontWeight: 700, color: '#34d399', fontSize: 18 }}>{fmt(p.mrr_plan)}</div>
                  <div style={{ color: 'var(--text-3)', fontSize: 11 }}>MRR</div>
                </div>
              </div>

              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => setModal(p)} style={{ flex: 1, padding: '8px 0', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-2)', cursor: 'pointer', fontSize: 13 }}>Editar</button>
                <button onClick={() => toggleActivo(p)} style={{ flex: 1, padding: '8px 0', borderRadius: 8, border: 'none', background: p.activo ? '#f87171' + '22' : '#34d399' + '22', color: p.activo ? '#f87171' : '#34d399', cursor: 'pointer', fontSize: 13 }}>
                  {p.activo ? 'Desactivar' : 'Activar'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      {modal !== null && <PlanModal data={Object.keys(modal).length ? modal : null} onClose={() => setModal(null)} onSaved={() => { setModal(null); cargar(); }} />}
    </div>
  );
}

function PlanModal({ data, onClose, onSaved }) {
  const esNuevo = !data?.id;
  const [form, setForm] = useState({
    nombre: data?.nombre || '',
    descripcion: data?.descripcion || '',
    precio_mensual: data?.precio_mensual || '',
    precio_anual: data?.precio_anual || '',
    max_sillas: data?.max_sillas || '',
    max_cobros_mes: data?.max_cobros_mes ?? 0,
    soporte: data?.soporte || 'email',
    color: data?.color || '#38bdf8',
    modulo_ventas: data?.modulo_ventas ?? 0,
  });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const inputStyle = { width: '100%', padding: '9px 12px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-app)', color: 'var(--text-1s)', fontSize: 13, outline: 'none', boxSizing: 'border-box' };

  const guardar = async () => {
    if (!form.nombre || !form.precio_mensual || !form.max_sillas) return toast.error('Nombre, precio y sillas son requeridos');
    setSaving(true);
    try {
      if (esNuevo) {
        await api.post('/admin/planes', form);
        toast.success('Plan creado');
      } else {
        await api.put(`/admin/planes/${data.id}`, form);
        toast.success('Plan actualizado');
      }
      onSaved();
    } catch (e) {
      toast.error(e.response?.data?.error || 'Error');
    } finally { setSaving(false); }
  };

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#00000080', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 }}>
      <div style={{ background: 'var(--bg-card)', borderRadius: 16, padding: 28, width: '100%', maxWidth: 500, border: '1px solid var(--border)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 22 }}>
          <h2 style={{ margin: 0, fontSize: 17, color: 'var(--text-1)' }}>{esNuevo ? 'Nuevo Plan' : `Editar: ${data.nombre}`}</h2>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-3)', cursor: 'pointer', fontSize: 20 }}>×</button>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
          <div style={{ gridColumn: '1/-1' }}>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Nombre *</label>
            <input style={inputStyle} value={form.nombre} onChange={e => set('nombre', e.target.value)} placeholder="Básico, Profesional..." />
          </div>
          <div style={{ gridColumn: '1/-1' }}>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Descripción</label>
            <input style={inputStyle} value={form.descripcion} onChange={e => set('descripcion', e.target.value)} placeholder="Descripción del plan" />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Precio mensual (COP) *</label>
            <input style={inputStyle} type="number" value={form.precio_mensual} onChange={e => set('precio_mensual', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Precio anual (COP)</label>
            <input style={inputStyle} type="number" value={form.precio_anual} onChange={e => set('precio_anual', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Máximo sillas *</label>
            <input style={inputStyle} type="number" value={form.max_sillas} onChange={e => set('max_sillas', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Cobros/mes (0 = ilimitado)</label>
            <input style={inputStyle} type="number" value={form.max_cobros_mes} onChange={e => set('max_cobros_mes', e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Soporte</label>
            <select style={inputStyle} value={form.soporte} onChange={e => set('soporte', e.target.value)}>
              {['email','chat','telefono','dedicado'].map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div style={{ gridColumn: '1/-1', display: 'flex', alignItems: 'center', gap: 12, padding: '10px 14px', background: 'var(--bg-app)', borderRadius: 10 }}>
            <label style={{ fontSize: 13, color: 'var(--text-2)', flex: 1 }}>Módulo de ventas e inventario (Prestam.io Cart)</label>
            <button
              type="button"
              onClick={() => set('modulo_ventas', form.modulo_ventas ? 0 : 1)}
              style={{ padding: '6px 14px', borderRadius: 20, border: 'none', cursor: 'pointer', fontWeight: 600, fontSize: 12, background: form.modulo_ventas ? '#0f3d2e' : '#1e293b', color: form.modulo_ventas ? '#34d399' : '#475569', transition: 'all 0.2s' }}
            >
              {form.modulo_ventas ? '✓ Activado' : 'Desactivado'}
            </button>
          </div>
          <div>
            <label style={{ fontSize: 12, color: 'var(--text-3)', display: 'block', marginBottom: 4 }}>Color</label>
            <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              <input type="color" value={form.color} onChange={e => set('color', e.target.value)} style={{ width: 42, height: 36, padding: 2, borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg-app)', cursor: 'pointer' }} />
              <input style={{ ...inputStyle, flex: 1 }} value={form.color} onChange={e => set('color', e.target.value)} placeholder="#38bdf8" />
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 22 }}>
          <button onClick={onClose} style={{ padding: '9px 18px', borderRadius: 8, border: '1px solid var(--border)', background: 'transparent', color: 'var(--text-2)', cursor: 'pointer', fontSize: 13 }}>Cancelar</button>
          <button onClick={guardar} disabled={saving} style={{ padding: '9px 20px', borderRadius: 8, border: 'none', background: '#6366f1', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 13 }}>{saving ? 'Guardando...' : 'Guardar'}</button>
        </div>
      </div>
    </div>
  );
}
